import { FiAward } from "react-icons/fi";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { getProgramLog, getProgramLogForClient } from "../../../api/programLog";
import { LogbookEntry, LogbookEntrySkeleton } from "../../../components/LogbookEntry";
import { useExercise } from "../../../exercise/ExerciseContext";
import { formatToTwoDecimalPlacesIfNotWholeNumber } from "../../../utils/numberUtils";
import { AppPageLayout } from "../../PageLayouts";

interface Params {
    id: string;
    log: string;
}

export const ClientLogbookItemPage: React.FC = () => {
    const { id, log } = useParams<Params>();
    const { getExerciseById } = useExercise();

    const { isLoading, error, data: logbookItem, refetch } = useQuery(`coach/logbook/item/${id}/${log}`, async () => { 
        const result = await getProgramLogForClient(id, log);
        if(!result.isError) {
            return result.content;
        }   
    });

    const documentTitle = logbookItem?.log.programDay.name ? `${logbookItem?.log.programDay.name} Log` : 'Logbook Entry';

    return (
        <AppPageLayout title={documentTitle}>
        {!isLoading && logbookItem &&
                <div className="">
                    <div className="w-full">
                        <div className="flex-1 p-6">
                            <h1 className="font-medium text-2xl">{logbookItem.log.programDay.name ?? "Workout"}</h1>
                            <hr className="my-4" />
                            <LogbookEntry entry={logbookItem} />
                        </div>
                            {logbookItem.personalBests.length > 0 &&
                                <div className="flex-none w-full p-6">
                                    <h2 className="font-medium text-xl pt-1">{logbookItem.personalBests.length} personal best{logbookItem.personalBests.length > 1 ? 's' : ''} (this session)</h2>
                                    <hr className="my-4" />
                                    {logbookItem.personalBests.map(personalBest => {
                                        const exercise = getExerciseById(personalBest.exercise);

                                        return (
                                            <div className="bg-white rounded-md flex items-center justify-center p-4 mb-4 border border-gray-200 w-full" key={personalBest._id}>
                                                <FiAward className="w-6 h-6 text-yellow-400" />
                                                <div className="font-medium ml-2">{exercise?.name} - {personalBest.reps} reps {personalBest.weight}kg</div>
                                                <div className="font-medium text-green-500 ml-2">+{formatToTwoDecimalPlacesIfNotWholeNumber(personalBest.difference)}kg</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            }
                    </div>
                </div>
            }
            {isLoading &&
                <LogbookEntrySkeleton />
            }
        </AppPageLayout>
    );
};